.bookingwidget {
  position: relative;
  z-index: 40;
}
